import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import './WhatsInOut.css';
import Slider from 'react-slick';
// import marketup from '../../Images/arrow-up.png';
// import marketdown from '../../../Images/Images/arrow-down.png';
import { useNavigate } from "react-router-dom";
import Pagination from '../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'


function WhatsInOut() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [DataHolding, setDataHolding] = useState([]);
    const [DataMfHoldingdrop, setDataMfHoldingdrop] = useState([]);
    const [DataMfHoldingdropcat, setDataMfHoldingdropcat] = useState([]);
    const [data, setData] = useState([]);
    const [type, settype] = useState('In');
    const [loadingshow, setloadingshow] = useState(false);
    const [Category, setCategory] = useState('5946');
    // const [schname, setschname] = useState('sch');
    const [DataMfHoldingdropMfcode, setDataMfHoldingdropMfcode] = useState([]);
    // const [CategorymfCode, setCategoryDividend] = useState('5946');
    const [DataMfHoldingdropSheme, setDataMfHoldingdropSheme] = useState([]);
    // const [CategorymfCode, setCategoryDividend] = useState('1');
    const [valueschemename, setValueschemename] = useState([]);
    const [valueschemename1, setValueschemename1] = useState([]);
    const [valueschemename2, setValueschemename2] = useState([]);
    const [Sheme, setSheme] = useState('26');
    const [ShemeCode, setShemeCode] = useState('10645');
    let getDataHoldingdrop, getDataHoldingdropcat, getDataHoldingdropSheme, getDataHolding, PageSize = 5;


    useEffect(() => {

        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";
        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdrop) => {
                getDataHoldingdrop = dataMHoldingdrop.data;
                setDataMfHoldingdrop(getDataHoldingdrop);
                setloadingshow(false);
                // var schemenameN = document.getElementById('selectScheme').value;
                // var schemeCat = document.getElementById('selectCategory').value;
                // setValueschemename2(schemeCat);
                // setValueschemename1(schemenameN)
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropcat) => {
                getDataHoldingdropcat = dataMHoldingdropcat.data;
                setDataMfHoldingdropcat(getDataHoldingdropcat);
                setloadingshow(false);
                // var schemenameN = document.getElementById('selectScheme').value;
                // var schemeCat = document.getElementById('selectCategory').value;
                // setValueschemename2(schemeCat);
                // setValueschemename1(schemenameN)


                //console.log(getDataHoldingdropcat, "MfHoldingDropcat")
            })
            .catch((error) => {
            });

        // alert(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
        fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropSheme) => {
                getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                setloadingshow(false);
                // var schemenameN = document.getElementById('selectScheme').value;
                // var schemeCat = document.getElementById('selectCategory').value;
                // setValueschemename2(schemeCat);
                // setValueschemename1(schemenameN)
                //console.log(getDataHoldingdropSheme, "MfHoldingDropSheme")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "WhatsInOutUnchanged";
        // alert(`${getUrl}/sch/${type}/${ShemeCode}/-`)
        fetch(`${getUrl}/sch/${type}/${ShemeCode}/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHolding = dataMHolding.data;
                setDataHolding(getDataHolding);
                setloadingshow(false);
                // console.log(getDataHolding, "WhatsInOutUnchanged")
                // setData(data.data);
            })
            .catch((error) => {
                //console.log("not found the api");
            });



    }, [type, ShemeCode, Category, Sheme]);

    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";
        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdrop) => {
                getDataHoldingdrop = dataMHoldingdrop.data;
                setDataMfHoldingdrop(getDataHoldingdrop);
                var schemename = getDataHoldingdrop[0].co_name;
                setValueschemename(schemename)
                setloadingshow(false);
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropcat) => {
                getDataHoldingdropcat = dataMHoldingdropcat.data;
                setDataMfHoldingdropcat(getDataHoldingdropcat);
                var schemename = getDataHoldingdropcat[0].VCLASS;
                setValueschemename1(schemename)
                setloadingshow(false);


                //console.log(getDataHoldingdropcat, "MfHoldingDropcat")
            })
            .catch((error) => {
            });


        fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropSheme) => {
                getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                var schemename = getDataHoldingdropSheme[0].SCH_NAME;
                setValueschemename2(schemename)
                setloadingshow(false);
                //console.log(getDataHoldingdropSheme, "MfHoldingDropSheme")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "WhatsInOutUnchanged";
        fetch(`${getUrl}/sch/${type}/${ShemeCode}/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHolding = dataMHolding.data;
                setDataHolding(getDataHolding);
                setloadingshow(false);
                // console.log(getDataHolding, "WhatsInOutUnchanged")
                // setData(data.data);
            })
            .catch((error) => {
                //console.log("not found the api");
            });

    }, []);

    const currentTableData = useMemo(() => {
        if (DataHolding != null && DataHolding != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataHolding != null && DataHolding != []) {
                if (DataHolding.length > 0) {
                    return DataHolding.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataHolding]);


    const handleSelect = (key) => {
        if (key === "whatin") {
            settype('in');
        } else if (key === "whatout") {
            settype('Out');
        } else {
            settype('un');
        }


    }
    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>What's In & Out</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='InOut-loser-sc'>

                            <div className='InOut-header'>
                                <h2><span>What’s In /Out</span></h2>
                            </div>
                            <MarketMF optionValue="What's In & Out" />
                            <div className='InOut-right'>
                                <div className='RightOut-inner-select'>
                                   
                                   {/* aria-label="Select Fund House" */}
                                    <select aria-label="Select Fund House" onChange={(event) => { setCategory(event.target.value); setValueschemename1('selectCategory'); document.getElementById("select-cat").selectedIndex = "0"; }}>
                                        <option>Select Fund House</option>
                                        {DataMfHoldingdrop && DataMfHoldingdrop.map(
                                            ({ mf_cocode, co_name }) => (
                                                <option value={mf_cocode} selected={valueschemename === co_name}>{co_name}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className='InOut-inner-select'>

                                    {/* aria-label="Select Category" */}
                                    <select aria-label="Select Category" id="select-cat" onChange={(event) => { setSheme(event.target.value); setValueschemename2('selectScheme'); document.getElementById("select-sch").selectedIndex = "0"; }}>
                                        <option id="selectCategory">Select Category</option>
                                        {DataMfHoldingdropcat && DataMfHoldingdropcat.map(
                                            ({ VCLASSCODE, VCLASS }) => (

                                                <option value={VCLASSCODE} selected={valueschemename1 === VCLASS || valueschemename1 === "selectCategory"}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='InOut-inner-select'>

                                    {/* aria-label="Select Scheme" */}
                                    <select aria-label="Select Scheme" id="select-sch" onChange={(event) => { setShemeCode(event.target.value); setValueschemename1('selectCategory'); }}>
                                        <option id="selectScheme">Select Scheme</option>
                                        {DataMfHoldingdropSheme && DataMfHoldingdropSheme.map(
                                            ({ MF_SCHCODE, SCH_NAME }) => (

                                                <option value={MF_SCHCODE} selected={valueschemename2 === SCH_NAME || valueschemename2 === "selectScheme"}>{SCH_NAME}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                            </div>
                            <div className="ipo-common">
                                <Tabs defaultActiveKey="whatin"
                                    transition={true}
                                    id="noanim-tab-example"
                                    className="mb-3" onSelect={(e) => handleSelect(e)}>
                                    <Tab eventKey="whatin" title="What's In">
                                        <div className='InOut-table table-responsive'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-left'>Company Name</th>
                                                        <th className='text-right'>Market Value(&#8377;)</th>
                                                        <th className='text-right'>Holding(%)</th>
                                                        <th className='text-right'>No. Of Shares</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentTableData && currentTableData.map(({ CO_NAME, NO_SHARES, mktvalue, Perc_Hold }) => (
                                                        <tr>
                                                            <td className='text-left'>{CO_NAME}</td>
                                                            <td className='text-right'>{mktvalue}</td>
                                                            <td className='text-right'>{Perc_Hold.toFixed(2)}</td>
                                                            <td className='text-right'>{NO_SHARES.toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {loadingshow ? <div className="textcentervertex">
                                                <Vortex
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    ariaLabel="vortex-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass="vortex-wrapper"
                                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                />
                                                <div className="model_popup">Please Wait...</div>
                                            </div> : ""
                                            }

                                        </div>
                                    </Tab>
                                    <Tab eventKey="whatout" title="What's Out">
                                        <div className='InOut-table table-responsive'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-left'>Company Name</th>
                                                        <th className='text-right'>Market Value(&#8377;)</th>
                                                        <th className='text-right'>Holding(%)</th>
                                                        <th className='text-right'>No. Of Shares</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentTableData && currentTableData.map(({ CO_NAME, NO_SHARES, mktvalue, Perc_Hold }) => (
                                                        <tr>
                                                            <td className='text-left'>{CO_NAME}</td>
                                                            <td className='text-right'>{mktvalue}</td>
                                                            <td className='text-right'>{Perc_Hold.toFixed(2)}</td>
                                                            <td className='text-right'>{NO_SHARES.toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {loadingshow ? <div className="textcentervertex">
                                                <Vortex
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    ariaLabel="vortex-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass="vortex-wrapper"
                                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                />
                                                <div className="model_popup">Please Wait...</div>
                                            </div> : ""
                                            }

                                        </div>
                                    </Tab>
                                    <Tab eventKey="Unchange" title="Unchanged">
                                        <div className='InOut-table table-responsive'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-left'>Company Name</th>
                                                        <th className='text-right'>Market Value(&#8377;)</th>
                                                        <th className='text-right'>Holding(%)</th>
                                                        <th className='text-right'>No. Of Shares</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentTableData && currentTableData.map(({ CO_NAME, NO_SHARES, mktvalue, Perc_Hold }) => (
                                                        <tr>
                                                            <td className='text-left'>{CO_NAME}</td>
                                                            <td className='text-right'>{mktvalue}</td>
                                                            <td className='text-right'>{Perc_Hold.toFixed(2)}</td>
                                                            <td className='text-right'>{NO_SHARES.toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {loadingshow ? <div className="textcentervertex">
                                                <Vortex
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    ariaLabel="vortex-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass="vortex-wrapper"
                                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                />
                                                <div className="model_popup">Please Wait...</div>
                                            </div> : ""
                                            }

                                        </div>

                                    </Tab>
                                </Tabs>
                            </div>

                            {(DataHolding != null && DataHolding != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(DataHolding.length != null) ? DataHolding.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default WhatsInOut